/** @deprecated Import from `src/mocks/inspiration` for new code. */
export {
  createFeedItems,
  createGetInspirationFeedMock,
} from '../../mocks/inspiration';
